var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourtsNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3457 24.0303V24.1765H18.4919H19.3168H19.3343H19.4805V24.0303V16.7646C19.4805 14.95 20.9595 13.4711 22.7741 13.4711H27.8636H28.0098V13.3248V12.5V12.3538H27.8636H22.7741C20.3241 12.3538 18.3457 14.3322 18.3457 16.7822V24.0303Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.463 26.0312V25.885H19.3168H18.4919H18.3457V26.0312V36.5787V36.7249H18.4919H19.3168H19.463V36.5787V26.0312Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4009 39.0724V39.2186H26.5471H31.619H31.6366V39.2185C34.0789 39.209 36.0474 37.2164 36.0474 34.7902V25.7695V25.6233H35.9012H35.0764H34.9302V25.7695V34.8077C34.9302 36.6224 33.4512 38.1013 31.6366 38.1013H26.5471H26.4009V38.2475V39.0724Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0648 14.9922V14.846H35.9186H35.0938H34.9475V14.9922V24.0304V24.1766H35.0938H35.9186H36.0648V24.0304V14.9922Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.357 27.3884H34.4041L34.4424 27.3609L39.4967 23.7281L39.8653 23.4632H39.4114H14.9995H14.5456L14.9142 23.7281L19.9685 27.3609L20.0068 27.3884H20.0539H34.357ZM36.3772 24.598L34.0467 26.2711H20.3817L18.0512 24.598H36.3772Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5709 26.8203V26.6741H27.4247H26.5999H26.4536V26.8203V33.6121V33.7583H26.5999H27.4247H27.5709V33.6121V26.8203Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5709 16.75V16.6038H27.4247H26.5999H26.4536V16.75V24.0157V24.1619H26.5999H27.4247H27.5709V24.0157V16.75Z",
    fill: "#1E1850",
    stroke: "#1E1850",
    strokeWidth: 0.292419,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtsNotActive);
export default __webpack_public_path__ + "static/media/courts-not-active.8cb32c26c07aaa5178b286523a12b143.svg";
export { ForwardRef as ReactComponent };